var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
import React from 'react';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { BasePartner, } from '../BasePartner';
import { SourceOfCare } from '../../../../clearstep/proto/results_pb';
import CareCard from '../../../CareCard/CareCard';
import { buildCareCardButtons, buildCareCardFromCareOption, buildCareCardFromPropsObject, } from '../../../CareCard/CareCardBuilder';
import { optionWithCareDetailCard } from '../CareDetails';
import { SpecialistCareDetail } from '../../../../../util/care_details/SpecialistCareDetail';
import PartnerCareLocation from '../../../PartnerCareLocation/PartnerCareLocation';
import '../../../../clearstep/Types';
import '../../../../clearstep/proto/care_locations_pb';
import { StethoscopeCircleIcon } from '../../../../svg/StethoscopeCircleIcon';
import Button from '../../../../tailwind_common/Button';
import { logEvent, MessageType } from '../../../../../util/EventLog';
import { THEME } from '../../../../clearstep/util/Theme';
import ResultsCard from '../../../ResultsCard/ResultsCard';
import { isSmallScreen } from '../../../../clearstep/util/AppHelpers';
import { VirtualVisitCareOptionIcon } from '../../../../svg/VirtualVisitCareOptionIcon';
import { CovidInformationCareDetailDescriptor } from '../../../../../util/care_details/CovidInformationCareDetail';
// Note: this will be difficult to wrap in translation hook
var BSWHSpecialistDescription = 'Baylor Scott and White offers a broad range of experienced specialists providing personalized treatment for each patient, using the latest diagnostics and therapies to arrive at the best course of treatment.';
var BSWHSpecialistCTA = 'Find a specialist near you';
var specialistCustomizations = (_a = {},
    _a[SpecialistCareDetail.CLINICAL_PSYCHOLOGIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care?sortBy=NextAvailableAppointment&keyword=Behavioral+Health&vector=specialtyGroupName',
            },
        ],
    },
    _a[SpecialistCareDetail.THERAPIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care?sortBy=NextAvailableAppointment&keyword=Behavioral+Health&vector=specialtyGroupName',
            },
        ],
    },
    _a[SpecialistCareDetail.CARDIOLOGY] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialtyGroupName&keyword=Cardiology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.DENTISTRY] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialty&keyword=Dentistry&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.DERMATOLOGY] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialtyGroupName&keyword=Dermatology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.PEDIATRICS] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialty&keyword=Family+Medicine&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.GASTROENTEROLOGY] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialty&keyword=Gastroenterology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.NEUROLOGY] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialtyGroupName&keyword=Neurology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.OBGYN] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialty&keyword=Obstetrics+and+Gynecology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.OPHTHALMOLOGIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialty&keyword=Ophthalmology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.FOOT_SPECIALIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialty&keyword=Foot+and+Ankle+Surgery&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.ANKLE_SPECIALIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialty&keyword=Foot+and+Ankle+Surgery&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.GENERAL_ORTHOPEDIC] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care?&vector=specialtyGroupName&keyword=Orthopedic%20Surgery&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.HAND_SPECIALIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care?vector=specialty&keyword=Hand%20and%20Wrist%20Surgery&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.WRIST_SPECIALIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care?vector=specialty&keyword=Hand%20and%20Wrist%20Surgery&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.HIP_SPECIALIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care?vector=specialty&keyword=Hip%20Surgery&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.KNEE_SPECIALIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialty&keyword=Knee+Surgery&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.SHOULDER_SPECIALIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialty&keyword=Shoulder+Surgery&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.SPINE_SPECIALIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?&vector=specialty&keyword=Orthopedic+Spine+Surgery&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.ENT] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialtyGroupName&keyword=Otolaryngology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.OTOLARYNGOLOGY] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialtyGroupName&keyword=Otolaryngology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.PULMONOLOGIST] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?vector=specialtyGroupName&keyword=Pulmonology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.UROLOGY] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?&vector=specialtyGroupName&keyword=Urology&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[SpecialistCareDetail.PODIATRY] = {
        description: BSWHSpecialistDescription,
        buttons: [
            {
                cta: BSWHSpecialistCTA,
                url: 'https://www.bswhealth.com/find-care#?distance=10&vector=specialty&keyword=Podiatry&location=Dallas%2C+TX&sortBy=NextAvailableAppointment',
            },
        ],
    },
    _a[CovidInformationCareDetailDescriptor.COVID_19_VACCINE_INFORMATION] = {
        title: 'COVID-19 Vaccine Information',
        buttons: [
            {
                cta: 'See more information',
                url: 'https://www.cdc.gov/covid/vaccines/stay-up-to-date.html',
            },
        ],
    },
    _a[CovidInformationCareDetailDescriptor.COVID_19_TESTING_INFORMATION] = {
        title: 'COVID-19 Testing Information',
        buttons: [
            {
                cta: 'See more information',
                url: 'https://www.bswhealthplan.com/Providers/Pages/COVID-19.aspx',
            },
        ],
    },
    _a);
/* eslint-disable @typescript-eslint/no-unused-vars */
var BSWHPartner = /** @class */ (function (_super) {
    __extends(BSWHPartner, _super);
    function BSWHPartner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.behavioralHealthOption = function (options) {
            var behavioralHealthOption = options.behavioralHealthOption;
            return behavioralHealthOption
                ? buildCareCardFromPropsObject({
                    title: behavioralHealthOption.subtitle,
                    description: behavioralHealthOption.description,
                    useMarkdown: behavioralHealthOption.isMarkdown,
                    heading: behavioralHealthOption.heading,
                    buttons: buildCareCardButtons(behavioralHealthOption.buttons),
                    noMargin: true,
                })
                : null;
        };
        return _this;
    }
    BSWHPartner.prototype.virtualVisitOptions = function (soc) {
        return soc ? buildCareCardFromCareOption(soc) : null;
    };
    BSWHPartner.prototype.careOptionDescription = function (options) {
        var careTypeList = [
            SourceOfCare.Type.PRIMARY_CARE,
            SourceOfCare.Type.ASYNCH_CARE,
            SourceOfCare.Type.ASYNCH_CARE_ASTHMA_MEDICATION_REFILL,
            SourceOfCare.Type.ASYNCH_CARE_COLD_SORES,
            SourceOfCare.Type.ASYNCH_CARE_ECZEMA,
            SourceOfCare.Type.URGENT_CARE,
            SourceOfCare.Type.TELEMEDICINE,
            SourceOfCare.Type.SPECIALIST,
            SourceOfCare.Type.AMBULANCE,
            SourceOfCare.Type.POISON_CONTROL,
            SourceOfCare.Type.HOME,
        ];
        if (careTypeList.includes(options.careType)) {
            return React.createElement(React.Fragment, null);
        }
        return null;
    };
    BSWHPartner.prototype.showCareOptionDescription = function (options) {
        return (options.careType !== SourceOfCare.Type.BEHAVIORAL_HEALTH &&
            options.careType !== SourceOfCare.Type.DENTIST);
    };
    BSWHPartner.prototype.urgentCareOption = function (options) {
        var careLocations = options === null || options === void 0 ? void 0 : options.careLocations;
        var numberOfCareLocations = options === null || options === void 0 ? void 0 : options.numberOfCareLocations;
        return BSWHPartner.careOptionsWithLocations(options, careLocations, numberOfCareLocations, false);
    };
    BSWHPartner.prototype.primaryCareOption = function (options) {
        return options ? buildCareCardFromCareOption(options) : null;
    };
    BSWHPartner.prototype.poisonControlOption = function (options) {
        return options
            ? buildCareCardFromPropsObject({
                title: options.subtitle,
                description: options.description,
                useMarkdown: options.isMarkdown,
                heading: options.heading,
                buttons: buildCareCardButtons(options.buttons),
                noMargin: true,
            })
            : null;
    };
    BSWHPartner.prototype.asynchCareOption = function (options) {
        return (options === null || options === void 0 ? void 0 : options.soc) ? buildCareCardFromCareOption(options.soc) : null;
    };
    BSWHPartner.prototype.getERFallbackCardCustomizations = function () {
        return this.getERCardCustomizations();
    };
    BSWHPartner.prototype.getERCardCustomizations = function () {
        return {
            description: 'Based on the severity of your symptoms, we recommend calling 911 or visiting an emergency room (ER) as quickly as possible.\n\nIf you are experiencing symptoms of a heart attack or stroke, call 911. Do not drive yourself to the hospital. Emergency medical teams are equipped to treat you in the ambulance and will alert the hospital when they are on the way.\n\nIf there isn’t a hospital shown below within 5 miles of your zip code please click the button to see more available locations nearby. There may be non - Baylor Scott & White hospitals closer to you. In the event of an emergency, please consider all care options prior to choosing where to go',
            findOtherLocationsUrl: 'https://www.bswhealth.com/find-care?sortBy=Distance&keyword=Emergency+Care&vector=clinicalTerm&tab=l',
            icon: React.createElement(StethoscopeCircleIcon, null),
        };
    };
    BSWHPartner.prototype.homeCareProviderOption = function (options) {
        var homeCareOption = options.homeCareOption;
        return homeCareOption ? buildCareCardFromCareOption(homeCareOption) : null;
    };
    BSWHPartner.prototype.renderDentistOption = function (options) {
        var sourceOfCare = options.sourceOfCare;
        return sourceOfCare ? buildCareCardFromCareOption(sourceOfCare) : null;
    };
    BSWHPartner.prototype.partnerOptionWithCareDetail = function (options) {
        return optionWithCareDetailCard(options.careDetails || [], specialistCustomizations);
    };
    BSWHPartner.prototype.showZipcodeInput = function (careOptions) {
        // Only show for ER, Urgent Care
        return careOptions.some(function (careOption) {
            return careOption.careType === SourceOfCare.Type.ER ||
                careOption.careType === SourceOfCare.Type.AMBULANCE ||
                careOption.careType === SourceOfCare.Type.HOSPITAL ||
                careOption.careType === SourceOfCare.Type.URGENT_CARE;
        });
    };
    BSWHPartner.careOptionsWithLocations = function (options, careLocations, numberOfCareLocations, includePhysicianImage) {
        if (options) {
            return (React.createElement("div", null,
                buildCareCardFromCareOption(options, undefined, Array.isArray(careLocations) && !!careLocations.length),
                React.createElement("br", null),
                React.createElement("br", null),
                Array.isArray(careLocations) &&
                    !!careLocations.length &&
                    careLocations
                        .slice(0, numberOfCareLocations !== null && numberOfCareLocations !== void 0 ? numberOfCareLocations : 5)
                        .map(function (careLocation) { return (React.createElement(PartnerCareLocation, { location: careLocation, key: careLocation.name, includePhysicianImage: includePhysicianImage, defaultImageIcon: "/static/images/partners/tufts/img-physician-placeholder.png", ctaForName: true, showDefaultLocationHours: false })); })));
        }
        return null;
    };
    BSWHPartner.prototype.schedulingLinkConfig = function (location) {
        var schedulingLink = location.schedulingLink;
        if (!schedulingLink) {
            return null;
        }
        var buttonText = 'See location details';
        var redirectTo = function (newUrl) {
            history.pushState({ previousUrl: window.location.href }, '', window.location.href);
            window.location.href = newUrl;
        };
        window.onpopstate = function (event) {
            if (event.state && event.state.previousUrl) {
                window.location.href = event.state.previousUrl;
            }
        };
        return {
            schedulingLinkImg: (React.createElement(Button, { alternative: true, onClick: function () {
                    logEvent(MessageType.CLICKED_PARTNER_CARE_OPTION, { data: { text: buttonText } }, { partner: THEME.partner });
                    redirectTo(schedulingLink);
                } }, buttonText)),
            schedulingLink: schedulingLink,
        };
    };
    BSWHPartner.prototype.covidDoctorTriageResponse = function (options) {
        var t = useTranslation().t;
        if (options.hasTelemedicineSupport) {
            // show mshs specific telemedicine card
            return (React.createElement(ResultsCard, { useDropdownRenderStyling: true },
                React.createElement("h2", null, t('common.findCareNearYou', 'Find care near you')),
                buildCareCardFromCareOption({
                    description: '',
                    isMarkdown: true,
                    heading: 'p',
                    buttons: [
                        {
                            clickEventName: '',
                            heading: 'h3',
                            text: '',
                            url: 'https://www.bswhealth.com/specialties/virtual-care',
                            cta: t('bswh.virtualVisit.learnMoreButtonText', 'Learn more'),
                            hasMarginTop: false,
                            useWhitespace: false,
                        },
                        {
                            clickEventName: '',
                            heading: 'h3',
                            text: '',
                            url: 'https://link.bswhealth.com/schedulevideovisit',
                            cta: t('bswh.virtualVisit.buttonText', 'Start a Visit'),
                            hasMarginTop: false,
                            useWhitespace: false,
                        },
                    ],
                    subtitle: t('bswh.virtualVisit.subtitle', "We're sorry you aren't feeling well. Based on your symptoms, you may benefit from a virtual urgent care visit through MyBSWHealth.") || '',
                })));
        }
        return this.covidDoctorTriageOptions(options);
    };
    BSWHPartner.prototype.covidDoctorTriageOptions = function (options) {
        var heightAndWidthSize = isSmallScreen() ? '28' : '56';
        return (React.createElement(ResultsCard, null,
            React.createElement("h2", null, t('common.findCareNearYou', 'Find care near you')),
            React.createElement(React.Fragment, null,
                options.hasTestingSupport && (React.createElement(CareCard, { title: t('basePartner.covidDoctorTriage.doctorCareCard.title', 'Speak with a doctor'), icon: React.createElement(VirtualVisitCareOptionIcon, { height: heightAndWidthSize, width: heightAndWidthSize }) })),
                options.hasTestingSupport && options.isTestToTreat && (React.createElement(CareCard, { useMarginTop: true, buttons: [
                        {
                            url: 'https://covid-19-test-to-treat-locator-dhhs.hub.arcgis.com/',
                            cta: t('basePartner.covidDoctorTriage.getTestedCareCard.cta', 'Get tested and treated for COVID-19 at a pharmacy near you'),
                        },
                    ] })))));
    };
    return BSWHPartner;
}(BasePartner));
export { BSWHPartner };
